// extracted by mini-css-extract-plugin
export default {"modalFooterActions":"CCModalClientRead_modalFooterActions__n4Cot","buttonSummary":"CCModalClientRead_buttonSummary__biSRx","buttonClose":"CCModalClientRead_buttonClose__HUvYG"};